import { render, staticRenderFns } from "./ProfileRequest.view.vue?vue&type=template&id=3ca22ceb&"
import script from "./ProfileRequest.view.vue?vue&type=script&lang=js&"
export * from "./ProfileRequest.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports